import { useLocation,useNavigate } from "react-router-dom";

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const getPathArray = (path) => {
  if (!path) path = "";
  const test = Array.from(path.split("/"));
  if (test.length > 0 && test[0] === "") test.shift();
  return test;
};

export function removeQueryParams(url) {
  const urlObject = new URL(url);
  const { protocol, host, pathname } = urlObject;
  const cleanUrl = `${protocol}//${host}${pathname}`;
  return cleanUrl;
}

export const getSimplestPathname = (path) => {
  if (!path) path = "";
  return path.replace(/\/|/g, "");
};

export const get1stPath = (path) => {
  if (!path) path = "";
  const listPath = path.split("/");
  // -> /jogos/jogo/:num
  // -> ["", "jogos", "jogo", :num]
  return listPath[1] ? listPath[1] : null;
};

export const check1stPath = (path = "", route) => {
  if (!path) path = "";
  const listPath = path.split("/");
  // -> /jogos/jogo/:num
  // -> ["", "jogos", "jogo", :num]
  return listPath[1] ? listPath[1] === route : false;
};

export const get2ndPath = (path) => {
  if (!path) path = "";
  const listPath = path.split("/");
  // -> /jogos/jogo/:num
  // -> ["", "jogos", "jogo", :num]
  return listPath[2] ? listPath[2] : null;
};

export const get3rdPath = (path) => {
  if (!path) path = "";
  const listPath = path.split("/");
  // -> /jogos/jogo/:num
  // -> ["", "jogos", "jogo", :num]
  return listPath[3] ? listPath[3] : null;
};
/*
 * {
 * key:value
 * key:"" //if = nothing
 * }
 *
 */
export const getQueryStringParams = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {})
    : {};
};

//url_activity === https://afinandoocerebro.com.br/(...)/casa_abandonada/index.html?nivel=0&id_usu="
//url_query === http://localhost:3000/jogos?id_usuario=20&id_game=
export const getBetaActivityUrl = (activityUrl, userToPlay) => {
  const newURL = activityUrl.split("?");
  const base_url = newURL[0];
  const activity_query = getQueryStringParams(newURL[1]);
  Object.keys(userToPlay).forEach((key) => {
    activity_query[key] = userToPlay[key];
  });
  const finalQueries = Object.keys(activity_query).map(
    (key) => key + "=" + activity_query[key]
  );
  return base_url + "?" + finalQueries.join("&");
};

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const safeNavigate = (to, options = {}) => {
    const { preserveParams = true, ...navOptions } = options;
    const targetPath = typeof to === "string" ? to : to.pathname;

    if (location.pathname === targetPath) {
      return;
    }

    if (preserveParams && location.search && typeof to === "string") {
      return navigate(`${to}${location.search}`, navOptions);
    }

    navigate(to, navOptions);
  };

  return safeNavigate;
};
